<template>
  <div class="adviceBox">
    <div class="adviceBox1">
      <div>
        <span @click="typeSend('1')" :class="type==1?'active':'item'">流程出库</span>
        <span @click="typeSend('2')" :class="type==2?'active':'item'">手动出库</span>
      </div>
      <div class="adviceBox1">

        <el-button style="margin-left: 10px;" class="color-main" type="primary" @click="doThing(1)">
          导出汇总
        </el-button>
        <el-button class="color-grey" @click="doThing(2)">
          <i class="fa fa-print"></i>
          打印
        </el-button>
      </div>
    </div>
    <div>
      <myCKJL ref="CKJLRef" v-if="type==1" :dictCatalogType="dictCatalogType"></myCKJL>
      <mySDCK ref="SDCKRef" v-if="type==2" :dictCatalogType="dictCatalogType"></mySDCK>
    </div>
    <printCK ref="printCKRef"></printCK>
    <!-- 新增弹窗 -->
    <div>
      <BaseDialog :title="title" :isshow="showTime" @handleShow="handleShows" width="700px" height="auto">
        <!-- 内容-->
        <div class="addform" style="margin-top: 20px;">
          <el-form :inline="true" :rules="rulesform" :model="ruleForm" ref="ruleForms" class="demo-form-inline w-144">
            <el-form-item label="时间：" prop="auto_out">
              <el-date-picker v-model="backoff_time" type="daterange" range-separator="至" start-placeholder="出库开始时间"
                end-placeholder="出库结束时间" value-format="YYYY-MM-DD" @change="timeChange" />
            </el-form-item>
          </el-form>
        </div>
        <el-divider />
        <div style="text-align: right">
          <el-button @click="showTime = false">取消</el-button>
          <el-button type="primary" @click="exportOrPrint">确定</el-button>
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>

  import { toRefs, reactive, onMounted, ref, getCurrentInstance, nextTick } from 'vue'
  import { Search, ArrowRightBold, ArrowLeftBold } from '@element-plus/icons-vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime, getFirstDayOfMonth, getLastDay } from '@/utils/tool'
  import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
  import myCKJL from '@/components/KCManager/ck/CKJL.vue'
  import mySDCK from '@/components/KCManager/ck/sdCK.vue'
  import printCK from '@/components/KCManager/printCK1'
  export default {
    components: {
      BaseDialog,
      myCKJL,
      mySDCK,
      ArrowRightBold,
      printCK
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props1) {
      let { proxy } = getCurrentInstance()

      const state = reactive({
        CKJLRef: null,
        type: '1',
        SDCKRef: null,
        dictCatalogType: '',
        backoff_time: '',
        showTime: false,
        typeDo: '',
        loading: null,
        title: ''
      })
      onMounted(() => {
        state.dictCatalogType = props1.dictCatalogType

      })
      // 
      const doThing = (code) => {
        state.showTime = true
        state.typeDo = code
        if (state.typeDo == 1) {
          state.title = '导出'
        } else {
          state.title = '打印'
        }
        state.backoff_time = [getFirstDayOfMonth(), getLastDay()]
      }
      const initData = () => {
        state.type = 1
        if (state.type == '1') {
          nextTick(() => {
            state.CKJLRef.tobody()
          })
        } else {
          nextTick(() => {
            state.SDCKRef.tobody()
          })
        }
      }
      const typeSend = (e) => {
        state.type = e
        if (state.type == '1') {
          nextTick(() => {
            state.CKJLRef.tobody()
          })
        } else {
          nextTick(() => {
            state.SDCKRef.tobody()
          })
        }
      }
      const timeChange = (e) => {
        console.log(state.typeDo)
        if (state.typeDo == 1) {

        } else {
          const time1 = new Date(e[0]).getTime()
          const time2 = new Date(e[1]).getTime()
          console.log(time1)
          const time3 = time2 - time1
          const time4 = 1000 * 3600 * 24 * 30
          if (time3 > time4) {
            ElMessage.error('时间间隔不能超过30天')
            return
          }
        }


      }
      const exportOrPrint = () => {
        if (state.typeDo == 1) {
          exportTable()
        } else {
          print()
        }
        state.showTime = false
      }
      // 导出
      const exportTable = (row) => {
        let url = ''
        let title = ''
        let time = TimestampToTime()
        //汇总
        if (props1.dictCatalogType == '164000000') {
          title = `科室耗材出库汇总${time}.xlsx`
        } else {
          title = `科室药品出库汇总${time}.xlsx`
        }
        url = '/api/export/outRecordExport'
        let data = {}
        if (state.backoff_time) {
          data = {
            out_start_time: state.backoff_time[0],
            out_end_time: state.backoff_time[1],
            dict_catalog_type: props1.dictCatalogType,
          }
        } else {
          data = {
            dict_catalog_type: props1.dictCatalogType,
          }
        }
        downLoadXlsx(url, data, title)
      }
      const print = async () => {
        ElMessage.success('请稍等...')
        let data = {}
        if (state.backoff_time) {
          data = {
            current: 1,
            size: 10000,
            out_start_time: state.backoff_time[0],
            out_end_time: state.backoff_time[1],
            dict_catalog_type: props1.dictCatalogType,
          }
        } else {
          data = {
            current: 1,
            size: 10000,
            dict_catalog_type: props1.dictCatalogType,
          }
        }
        let res = await service.post('/api/store_out_record/get_out_record_list', data)
        // state.loading.close()
        if (res.code === 0) {
          if (res.data.total > 0) {
            let userData = JSON.parse(localStorage.getItem('ms_userData'))
            let data = {}
            if (state.backoff_time) {
              data = {
                time: state.backoff_time[0] + '~' + state.backoff_time[1],
                name: userData.name,
                drug_list: res.data.records
              }
            } else {
              data = {
                time: '',
                name: userData.name,
                drug_list: res.data.records
              }
            }
            proxy.$refs.printCKRef.initData(data)
            nextTick(() => {
              proxy.$refs.printCKRef.print()
            })
          } else {
            ElMessage.error('暂无打印数据')
          }
        }
      }
      return {
        ...toRefs(state),
        typeSend,
        initData,
        timeChange,
        exportTable,
        exportOrPrint,
        doThing
      }
    },
  }
</script>


<style scoped>
  .adviceBox1 {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .active {
    cursor: pointer;
    padding: 5px 8px;
    font-size: 14px;
    color: #3166ae;
    border: 2px solid #3166ae;
    border-radius: 2px;
    margin-right: 10px;
    font-weight: 500;
  }

  .item {
    cursor: pointer;
    padding: 5px 8px;
    font-size: 14px;
    color: #333;
    border: 2px solid #e1e1e1;
    border-radius: 2px;
    margin-right: 10px;
    font-weight: 500;
  }
</style>